import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { GeolocationService } from "../services/geolocationservice";
import { sweetalert } from "../services/sweetalert";

@Component({
  selector: "app-selectcard",
  templateUrl: "./selectcard.component.html",
  styleUrls: ["./selectcard.component.css"],
})
export class SelectcardComponent implements OnInit {
  srcCustId: any;
  srcMobNo: any;
  loader: boolean = false;
  custmerId: string;
  mobileNo: string;
  manageCardDataList: any;
  validUpto: any;
  validUptoFino: any;
  emicardNum:any;
  encryptData:any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private service: GeolocationService,
    private alert: sweetalert
  ) {}

  ngOnInit(): void {
    localStorage.removeItem("encryptData");
    localStorage.removeItem("custmerId");
    localStorage.removeItem("mobileNo");
    this.loader = true;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.encryptData = params["data"]!= null ? params["data"] : null;
      localStorage.setItem("encryptData", this.encryptData);
       this.srcCustId = params["custID"]!= null ? params["custID"] : null;
       this.srcMobNo = params["mobile"]!= null ? params["mobile"] : null;
      // console.log("custemer ID:" + this.srcCustId);
      // console.log("mobile No:" + this.srcMobNo);

       localStorage.setItem("custmerId", this.srcCustId);
       localStorage.setItem("mobileNo", this.srcMobNo);
      (error) => {
        this.loader = false;
        console.error("Unable to Process");
      };
      this.loader = false;
    });
    if((this.encryptData !=null && this.encryptData !='') || ((this.srcCustId !=null &&  this.srcCustId !='' && this.srcMobNo !=null && this.srcMobNo !=''))){
      let reqObject = {
        custID: `${this.srcCustId}`,
        mobile: `${this.srcMobNo}`,
        data: `${this.encryptData}`
      }
      this.service
      .getManageCard(reqObject)
      .subscribe((data: any) => {
        this.loader = true;
        this.manageCardDataList = JSON.parse(data?.data);

        if (typeof data === "object") {
          console.log("event:" + JSON.stringify(data));

          this.manageCardDataList = JSON.parse(data.data);

          console.log(JSON.stringify(this.manageCardDataList));

          this.validUpto = [
            this.manageCardDataList.VALID_TILL.slice(0, 2),
            "/",
            this.manageCardDataList.VALID_TILL.slice(2),
          ].join("");
          this.validUptoFino = [
            this.manageCardDataList.FINO_VALID_TILL.slice(0, 2),
            "/",
            this.manageCardDataList.FINO_VALID_TILL.slice(2),
          ].join("");

          var input = this.manageCardDataList.EMI_CARD_NO;
          var counter = 0;
          var cardNumber = "";
          while (input.length) {
            if (counter <= 1) {
              cardNumber = cardNumber + " " + input.substr(0, 3);
              input = input.substr(3);
              counter++;
            } else {
              cardNumber = cardNumber + " " + input;
              break;
            }
          } this.emicardNum =cardNumber;

          localStorage.setItem(
            "emicardname",
            this.manageCardDataList.CUST_NAME
          );
          localStorage.setItem(
            "emicardnumber",
            this.emicardNum
          );
          localStorage.setItem("emicardvalidupto", this.validUpto);

          if (data.statusCode == "EX") {
            this.loader = false;
          } else if (data.statusCode == "SR") {
            this.loader = false;
          }
        }
      });
      this.loader = false;
    }else{
      this.alert.errorsweertalert("No Data Found..!!");
      this.loader = false;
    }
    
    
  }

  navigateFino() {
      // @ts-ignore
    Dialog1.showMsg1('InstaCardOldHome'); 
}
}